import { ErrorInfo } from "react";
import { getNRErrorInfo } from "@swiggy-private/js-utils";
import Blaze from "@swiggy-private/blaze.js";
import { filterHeadersFromSwiggyHeaders } from "./utils";

export const sendErrorBoundaryEvent = (
    error?: Error,
    errorInfo?: ErrorInfo,
    headers?: Record<string, string | undefined> | void,
) => {
    const swgyHeaders = headers ? filterHeadersFromSwiggyHeaders(headers) : {};
    const errorBoundaryEvents = getNRErrorInfo(error, errorInfo);
    Blaze.recordCustomEvent({
        eventType: "webview_error_boundary",
        appName: "portal_swiggy_money",
        ...errorBoundaryEvents,
        ...swgyHeaders,
    });
};
